import React from 'react'

import editUserEmailValidator from 'validators/edit-user-email'

import EditContainer from '../edit/edit-container'
import EditEmail from './edit-email-view'

const EditEmailContainer = () => (
  <EditContainer validator={editUserEmailValidator} successMessage='account.email_updated'>
    { formProps => <EditEmail {...formProps} /> }
  </EditContainer>
)

export default EditEmailContainer
